"use strict";

exports.__esModule = true;
exports.default = void 0;

var _schema = _interopRequireDefault(require("./schema"));

var _uiSchema = _interopRequireDefault(require("./uiSchema"));

var _formData = _interopRequireDefault(require("./formData.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  id: 2,
  name: 'condition',
  schemaType: "primus",
  schema: _schema.default,
  uiSchema: _uiSchema.default,
  formData: _formData.default
};
exports.default = _default;
module.exports = exports.default;